import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { abbrNumberFilter } from "app/filters/ngFilters";
import { SuggestedTopicPill } from "app/pages/activation/components/Shared/SuggestedTopicPill/SuggestedTopicPill";
import { MODAL_TEXTS } from "app/pages/activation/components/Topics/texts";
import { VOLUME_LABEL } from "app/pages/activation/components/Topics/Topic/Share/texts";
import {
    StyledIcon,
    StyledTopicGroup,
    StyledTopicKeywords,
    StyledTopicName,
} from "app/pages/activation/components/Topics/Topic/styles";

import { topicItemKeys } from "../automationKeys";
import type { TopicItemSchema } from "../Modal/Flow/AddTopicFlow/types";

import * as SC from "./styles";

export const TopicItem = ({
    topicName,
    isSelected,
    volume,
    isSuggestion,
    isMaxSelected,
    granularity,
    selectTopic,
}: TopicItemSchema) => (
    <SC.ItemContainer
        key={topicName}
        onClick={selectTopic(topicName, isSuggestion)}
        data-automation={topicItemKeys.container}
    >
        <StyledIcon>
            <SWReactIcons
                iconName="keyword-group"
                size="xs"
                iconColor={colorsPalettes.carbon[400]}
            />
        </StyledIcon>

        <div>
            <StyledTopicGroup>
                <StyledTopicName data-automation={topicItemKeys.name}>{topicName}</StyledTopicName>

                {isSuggestion ? <SuggestedTopicPill /> : null}
            </StyledTopicGroup>

            {volume ? (
                <StyledTopicKeywords data-automation={topicItemKeys.volume}>
                    {abbrNumberFilter()(volume)} {translate(VOLUME_LABEL, { granularity })}
                </StyledTopicKeywords>
            ) : null}
        </div>

        <SC.ButtonContainer>
            <IconButton
                type="flat"
                iconName={isSelected ? "checked" : "add"}
                iconSize="xs"
                isDisabled={isMaxSelected ? !isSelected : null}
                dataAutomation={topicItemKeys.btn}
            >
                {isSelected ? translate(MODAL_TEXTS.buttonSelected) : translate(MODAL_TEXTS.buttonAdd)}
            </IconButton>
        </SC.ButtonContainer>
    </SC.ItemContainer>
);
